import { NgModule } from '@angular/core';
import { SharedModule } from "app/shared/shared.module";
import { RouterModule } from "@angular/router";
import { CoreModule } from 'app/core/core.module';
import { COMPANY_ROUTES } from './company.routing';
import { CompanyService } from './services/company.service';
import { CompanyListComponent } from './component/company-list/company-list.component';
import { AddCompanyComponent } from './component/add-company/add-company.component';
import { CompanyDetailsComponent } from './component/company-details/company-details.component';
import { CompanyAuditListComponent } from './component/company-audit-list/company-audit-list.component';
import { AddCompanyAuditComponent } from './component/add-company-audit/add-company-audit.component';
import { CompanyAuditDetailsComponent } from './component/company-audit-details/company-audit-details.component';
import { CompanyUsersAddComponent } from './component/company-users-add/company-users-add.component';
import { CompanyUsersComponent } from './component/company-users/company-users.component';
import { CompanyAuditListTabComponent } from './component/company-audit-list-tab/company-audit-list-tab.component';
import { CompanyAuditTypeListComponent } from './component/company-audit-type-list/company-audit-type-list.component';
import { CompanyAuditTypeAddComponent } from './component/company-audit-type-add/company-audit-type-add.component';
import { CompanyAuditTemplateComponent } from './component/company-audit-template/company-audit-template.component';
import { CompanyAuditTemplateAddComponent } from './component/company-audit-template-add/company-audit-template-add.component';
import { CompanyAuditTemplatesListComponent } from './component/company-audit-templates-list/company-audit-templates-list.component';
import { CompanyLendersComponent } from 'app/company/component/company-lenders/company-lenders.component';
import { AuditTargetsComponent } from 'app/company/component/audit-targets/audit-targets.component';

@NgModule({
	imports: [
        CoreModule,
        SharedModule,
		RouterModule.forChild(COMPANY_ROUTES)
	],
    declarations: [
        CompanyListComponent,
        AddCompanyComponent,
        CompanyDetailsComponent,
        CompanyAuditListComponent,
        AddCompanyAuditComponent,
        CompanyAuditDetailsComponent,
        CompanyUsersAddComponent,
        CompanyUsersComponent,
        CompanyAuditListTabComponent,
        CompanyAuditTypeListComponent,
        CompanyAuditTypeAddComponent,
        CompanyAuditTemplateComponent,
        CompanyAuditTemplateAddComponent,
        CompanyAuditTemplatesListComponent,
        CompanyLendersComponent,
        AuditTargetsComponent
    ],
	providers: [CompanyService]
})
export class CompanyModule { }
